import { call, put, takeLatest } from "redux-saga/effects";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  GET_USER_ACCESS_LIST_REQUEST,
} from "../../Utils/Constant";
import { api } from "../Config/ApiInterface";
import { decrypt, encrypt } from "../../Utils/encrypt";
import { toast } from "react-toastify";

function* loginSaga(action) {
  try {
    let isSuperAdmin = action.payload.role === "super_admin"||action.payload.role==="hotel_admin"
    const { data } = yield call(
      api.post,
      isSuperAdmin ? "/master/auth/login" : "/auth/login",
      action.payload
    );
    const accessToken = data?.access_token;
    const refreshToken = data?.refresh_token;
    const user = data?.staff;
    const role = user?.staff?.role;
    localStorage.setItem("token", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("user", user);
    localStorage.setItem("role", role);

    yield put({
      type: LOGIN_SUCCESS,
      payload: {
        tokens: accessToken,
        user,
      },
    });

    //  dispatch({
    //       type: GET_USER_ACCESS_LIST_REQUEST,
    //       payload: { id: staffId },
    //     });
    if (role === "super_admin") {
      localStorage.setItem(
        "checkPermission",
        JSON.stringify([
          {
            resource: "create_admin",
            can_view: true,
            can_add: true,
            can_update: true,
            can_delete: true,
          },
        ])
      );
    } else {
      yield put({
        type: GET_USER_ACCESS_LIST_REQUEST,
        payload: { id: user?.id }, // or token etc.
      });
    }
  } catch (error) {
    yield put({
      type: LOGIN_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

function* logoutSaga(action) {
  try {
    yield call(api.post, "/auth/logout");
    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("hotel_id");
    localStorage.removeItem("hotel_name");
    localStorage.removeItem("checkPermission");
    // Notify reducer
    yield put({ type: LOGOUT_SUCCESS });
    yield put({ type: "CLEAR_USER_ACCESS" });
  } catch (error) {
    console.log("error", error);
    yield put({ type: LOGOUT_FAILURE, payload: error.message });
  }
}

function* forgotPasswordSaga(action) {
  try {
    yield call(api.post, "/auth/forgot-password", action.payload);
    yield put({ type: FORGOT_PASSWORD_SUCCESS });
  } catch (error) {
    yield put({
      type: FORGOT_PASSWORD_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

function* verifyOtpSaga(action) {
  try {
    yield call(api.post, "/auth/verify-otp", action.payload);
    yield put({ type: VERIFY_OTP_SUCCESS });
  } catch (error) {
    yield put({
      type: VERIFY_OTP_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

function* resetPasswordSaga(action) {
  try {
    const { data } = yield call(
      api.post,
      "/auth/reset-password",
      action.payload
    );

    const accessToken = data.token?.access?.token;
    const refreshToken = data.token?.refresh?.token;
    const user = data.user;
    const role = user?.role;

    localStorage.setItem("token", encrypt(accessToken));
    localStorage.setItem("refreshToken", encrypt(refreshToken));
    localStorage.setItem("user", encrypt(user));
    localStorage.setItem("role", encrypt(role));

    yield put({
      type: RESET_PASSWORD_SUCCESS,
      payload: {
        token: accessToken,
        user,
        role,
      },
    });
  } catch (error) {
    yield put({
      type: RESET_PASSWORD_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

function* createUserSaga(action) {
  try {
    const token = localStorage.getItem("token");
    yield call(api.post, "/auth/create-user", action.payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put({ type: CREATE_USER_SUCCESS });
    toast.success("User Created Successful");
  } catch (error) {
    yield put({
      type: CREATE_USER_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
}

export default function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  yield takeLatest(LOGOUT_REQUEST, logoutSaga);
  yield takeLatest(FORGOT_PASSWORD_REQUEST, forgotPasswordSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordSaga);
  yield takeLatest(CREATE_USER_REQUEST, createUserSaga);
}
